import { memo } from 'react'

export type DayDecision = 'accept' | 'decline' | null

export interface DayDecisionToggleProps {
  decision: DayDecision
  onChoose: (decision: DayDecision) => void
  disabled?: boolean
}

const INACTIVE = 'text-slate-500 hover:text-slate-800 hover:bg-white/70'
const BASE = 'px-3 py-1.5 text-xs font-bold rounded-lg transition-all duration-200'

export const DayDecisionToggle = memo(function DayDecisionToggle({
  decision,
  onChoose,
  disabled = false,
}: DayDecisionToggleProps) {
  return (
    <div className={`inline-flex bg-slate-100 rounded-[10px] p-[3px] gap-0.5 ${disabled ? 'opacity-50 pointer-events-none' : ''}`}>
      <button
        type="button"
        onClick={() => onChoose(null)}
        className={`${BASE} ${decision === null ? 'bg-amber-500 text-white shadow-[0_2px_8px_rgba(245,158,11,.35)]' : INACTIVE}`}
        aria-pressed={decision === null}
      >
        Offen
      </button>
      <button
        type="button"
        onClick={() => onChoose(decision === 'accept' ? null : 'accept')}
        className={`${BASE} ${decision === 'accept' ? 'bg-green-500 text-white shadow-[0_2px_8px_rgba(34,197,94,.35)]' : INACTIVE}`}
        aria-pressed={decision === 'accept'}
      >
        Übernehmen
      </button>
      <button
        type="button"
        onClick={() => onChoose(decision === 'decline' ? null : 'decline')}
        className={`${BASE} ${decision === 'decline' ? 'bg-red-500 text-white shadow-[0_2px_8px_rgba(239,68,68,.35)]' : INACTIVE}`}
        aria-pressed={decision === 'decline'}
      >
        Ablehnen
      </button>
    </div>
  )
})
